import {Modal} from "@mantine/core";
import React from "react";
import {Carousel} from "@mantine/carousel";
import {DocxSlide, PreviewItem} from "../../../../../types/PreviewTypes";

type ShowAttachmentModalProps = {
    opened: boolean,
    close: () => void,
    previewItems: PreviewItem[]
};

export function ShowAttachmentModal({ opened, close, previewItems}: ShowAttachmentModalProps) {
    return (
        <Modal
            className="preview-modal"
            opened={opened}
            onClose={close}
            title="Anhang-Vorschau"
            size="xl"
            keepMounted={true}
        >
            <Carousel withControls={previewItems.length > 1} slideSize="100%">
                {previewItems.map((item, index) => (
                    <Carousel.Slide key={index}>
                        {item.type === "image" && <img className="preview-item" src={item.url} alt={`Anhang ${index}`} style={{
                            objectFit: "contain"
                        }} onLoad={() => window.dispatchEvent(new Event("resize"))}/>}
                        {item.type === "pdf" &&
                            <iframe className="preview-item" src={item.url} style={{border: "none"}}
                                    onLoad={() => window.dispatchEvent(new Event("resize"))}/>}
                        {item.type === "docx" &&
                            <DocxSlide docx={{buffer: item.buffer!, name: item.name!}} index={index}/>}
                    </Carousel.Slide>
                ))}
            </Carousel>
        </Modal>
    )
}
